.input-container {
  display: flex;
}

.month-container {
  width: 150px;
  margin-right: 8px;
}

.year-container {
  width: 66px;
  padding-top: 4px;
}
